export const checkIfAdmin = (uid: string) => {
  return uid === "AvfsZbJ4eebCMWKNxEXfDg9kYlT2";
};
